// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c54a9bfe","885":"36dc91de"}[chunkId] + ".chunk.js";
};